import { gql } from "graphql-request";
import { apiSlice } from "../../../store/slices/api/apiSlice";

type InviteType =
  | "self"
  | "selfpaced"
  | "scheduled"
  | "assigned_by_self"
  | "all";

export const ScheduleApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createAssessmentSchedule: builder.mutation({
      query: ({ id, version, type, accessCriteria }: any) => ({
        url: `/assessment/schedule/create/${id}/${version}/${type}/scheduled/${accessCriteria}?accessCriteria=${accessCriteria}`,
        method: "POST"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getScheduleDetails: builder.query({
      query: (id: any) => ({
        url: `/assessment/schedule/${id}?access=candidate`,
        method: "GET"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getAllSchedules: builder.query({
      query: ({
        pageNumber,
        owner,
        observer,
        title,
        status,
        sortKey,
        sortOrder,
        accesscriteria
      }: any) => ({
        url: "/graphql",
        body: gql`
          query GetAllSchedules {
            getAllSchedules(
              searchFilters: {
                title: "${title}"
                status: ${status}
                stakeholder: { owner: ${owner}, observer: ${observer} }
                ${accesscriteria ? `accesscriteria: "${accesscriteria}"` : ""}
              }
              pageNumber: ${pageNumber}
              pageSize: 12
              sortKey: "${sortKey}"
              sortOrder: "${sortOrder}"
            ) {
        timestamp
        error
        version
        data {
            pageNumber
            pageSize
            totalCount
            searchResult {
             accesscriteria
                id
                status
                freezeflag
                title
                starttime
                endtime
                autocomplete
                createdby
                createdat
                updatedby
                updatedat
                stakeholder {
                    owner
                    observer
                    reviewer
                }
                
            }
        }
    }
          }
        `
      }),
      extraOptions: { service: "MCQ_Assessment" },
      serializeQueryArgs: ({ endpointName }) => {
        return endpointName;
      },
      merge: (currentCacheData, responseData, otherArgs) => {
        if (otherArgs.arg.pageNumber > 1) {
          const messageMap = new Map();
          [
            ...currentCacheData.getAllSchedules.data.searchResult,
            ...responseData.getAllSchedules.data.searchResult
          ].map((msg) => {
            if (!messageMap.has(msg.id)) {
              messageMap.set(msg.id, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            getAllSchedules: {
              ...responseData.getAllSchedules,
              data: {
                ...responseData.getAllSchedules.data,
                searchResult: mergedResult
              }
            }
          };
        } else return responseData;
      },
      forceRefetch({ currentArg, previousArg }) {
        return currentArg !== previousArg;
      }
    }),
    updateSchedule: builder.mutation({
      query: ({ scheduleId, payload }: any) => ({
        url: `/assessment/schedule/update/${scheduleId}`,
        method: "POST",
        body: payload
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    validateSchedule: builder.query({
      query: (id: any) => ({
        url: `/assessment/schedule/validate/${id}`,
        method: "GET"
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),

    getRemarksByQpId: builder.query({
      query: (id: any) => ({
        url: `/utility/get/${id}`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    }),
    updateScheduleStatus: builder.mutation({
      query: ({ scheduleId, payload }: any) => ({
        url: `/assessment/schedule/status/${scheduleId}`,
        method: "POST",
        body: payload
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getParticipantList: builder.query({
      query: (params: any) => ({
        url: `/invitation/getByScheduleId`,
        method: "GET",
        params: params
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    inviteParticipants: builder.mutation({
      query: ({ scheduleId, actionType, payload }: any) => ({
        url: `/invitation/${scheduleId}/${actionType}`,
        method: "POST",
        body: payload
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    removeInvite: builder.mutation({
      query: ({ scheduleId, actionType, payload }: any) => ({
        url: `/invitation/remove/invite/${scheduleId}/${actionType}`,
        method: "POST",
        body: payload
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    reInvite: builder.mutation({
      query: ({ scheduleId }: any) => ({
        url: `/invitation/${scheduleId}`,
        method: "POST",
        body: {}
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    freezeSchedule: builder.mutation({
      query: ({ scheduleId, freeze }: any) => ({
        url: `/assessment/schedule/freeze/${scheduleId}`,
        method: "POST",
        params: { freeze }
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    postCloneAssessmentLibrary: builder.mutation({
      query: ({ scheduleId, body }) => {
        return {
          url: `/assessment/schedule/clone/${scheduleId}`,
          method: "POST",
          body
        };
      },
      extraOptions: { service: "MCQ_Assessment" }
    }),
    deleteAssessment: builder.mutation({
      query: ({ scheduleId }) => {
        return {
          url: `/assessment/schedule/delete/${scheduleId}`,
          method: "POST"
        };
      },
      extraOptions: { service: "MCQ_Assessment" }
    }),
    rescheduleASchedule: builder.mutation({
      query: ({ scheduleId, body }) => {
        return {
          url: `/assessment/schedule/reSchedule/${scheduleId}`,
          method: "POST",
          body
        };
      },
      extraOptions: { service: "MCQ_Assessment" }
    }),
    getSchedulebyId: builder.query({
      query: ({ scheduleId }: any) => ({
        url: "/graphql",
        body: gql`
          query GetInvitationByScheduleId {
    getInvitationByScheduleId(
        request: { scheduleId: "${scheduleId}" }
    ) {
        timestamp
        error
        version
        data {
            scheduleId
            invitees {
                inviteId
                progressType
                completedAt
                obtainedMarks
                remarks
                invitedAt
                user {
                    id
                    email
                    lastworkingday
                    name
                    supervisor
                    groups
                }
                invitedBy {
                    email
                    employeeNumber
                    id
                    enabled
                    supervisor
                    name {
                        firstName
                        lastName
                        fullName
                        middleName
                    }
                }
            }
        }
    }
}
        `
      }),
      extraOptions: { service: "MCQ_Assessment" }
      // serializeQueryArgs: ({ endpointName }) => {
      //   return endpointName;
      // },
      // merge: (currentCacheData, responseData, otherArgs) => {
      //   if (otherArgs.arg.pageNumber > 1) {
      //     const messageMap = new Map();
      //     [
      //       ...currentCacheData.getAllSchedules.data.searchResult,
      //       ...responseData.getAllSchedules.data.searchResult,
      //     ].map((msg) => {
      //       if (!messageMap.has(msg.id)) {
      //         messageMap.set(msg.id, msg);
      //       }
      //     });
      //     const mergedResult = [...messageMap.values()];
      //     return {
      //       ...responseData,
      //       getAllSchedules: {
      //         ...responseData.getAllSchedules,
      //         data: {
      //           ...responseData.getAllSchedules.data,
      //           searchResult: mergedResult,
      //         },
      //       },
      //     };
      //   } else return responseData;
      // },
      // forceRefetch({ currentArg, previousArg }) {
      //   return currentArg !== previousArg;
      // },
    }),
    getSchedulebyIdV2: builder.query({
      query: ({
        scheduleId,
        attemptType,
        pageNo,
        pageCount,
        searchKeyName = "",
        inviteType = null,
        invitedBy = [],
        progressType = "",
        obtainedMarks = "",
        order = "ASC"
      }: {
        scheduleId: string;
        attemptType: string;
        pageNo: number;
        pageCount: number;
        searchKeyName?: string;
        inviteType?: InviteType | null;
        invitedBy?: string[];
        progressType?: string;
        obtainedMarks?: string;
        order?: string;
      }) => ({
        url: "/graphql",
        body: gql`
        query GetInvitationByScheduleId {
          getInvitationByScheduleIdV2(
            request: {
              scheduleId: "${scheduleId}"
              attemptType: "${attemptType}"
              pageNo: ${pageNo}
              pageCount: ${pageCount}
              searchKeyName: "${searchKeyName}"
              inviteType: "${inviteType}"
            }
          ) {
            timestamp
            error
            version
            data {
              scheduleId
              totalCount
              invitees {
                inviteId
                ongoingId
                progressType
                completedAt
                maxMarks
                obtainedMarks
                attemptCount {
                  inProgress
                  completed
                  total
                }
                remarks
                invitedAt
                startTime
                user {
                  id
                  email
                  lastworkingday
                  name
                  supervisor
                  groups
                }
                invitedBy {
                  email
                  employeeNumber
                  id
                  enabled
                  supervisor
                  name {
                    firstName
                    lastName
                    fullName
                    middleName
                  }
                }
              }
            }
          }
        }
      `
      }),
      extraOptions: { service: "MCQ_Assessment" }
    }),
    updateSelfInviteSchedule: builder.mutation({
      query: ({ scheduleId, payload }: any) => ({
        url: `/invitation/invite/public/${scheduleId}`,
        method: "POST",
        body: payload
      }),
      extraOptions: { service: "MCQ_Assessment" }
    })
  })
});

export const {
  useCreateAssessmentScheduleMutation,
  useGetScheduleDetailsQuery,
  useLazyGetScheduleDetailsQuery,
  useGetAllSchedulesQuery,
  useUpdateScheduleMutation,
  useLazyValidateScheduleQuery,
  useUpdateScheduleStatusMutation,
  useGetParticipantListQuery,
  useInviteParticipantsMutation,
  useRemoveInviteMutation,
  useFreezeScheduleMutation,
  useGetSchedulebyIdQuery,
  useGetSchedulebyIdV2Query,
  useGetRemarksByQpIdQuery,
  useLazyGetRemarksByQpIdQuery,
  usePostCloneAssessmentLibraryMutation,
  useRescheduleAScheduleMutation,
  useDeleteAssessmentMutation,
  useReInviteMutation,
  useUpdateSelfInviteScheduleMutation
} = ScheduleApiSlice;
